export enum LookupTableType {
  State = 1,
  Country = 2,
  None = 3,
  YesValue = 4,
  NoValue = 5,
  Boolean = 9,
}
